document.addEventListener("DOMContentLoaded", () => {
  const moveableButton = document.querySelector(".product-form"); // Select button by class
  const originalContainer = moveableButton.parentNode; // Dynamically capture the original container
  const targetContainer = document.getElementById("targetContainer");
  let isInOriginalPosition = true;

  window.addEventListener("scroll", () => {
    if (window.innerWidth <= 768) {
      // Check if the device is likely a mobile device
      const scrollThreshold = 800; // Using mobile scroll threshold
      const currentScroll = window.pageYOffset;

      if (currentScroll >= scrollThreshold && isInOriginalPosition) {
        targetContainer.appendChild(moveableButton); // Move the button
        isInOriginalPosition = false;
      } else if (currentScroll < scrollThreshold && !isInOriginalPosition) {
        originalContainer.appendChild(moveableButton); // Move it back
        isInOriginalPosition = true;
      }
    }
  });
});
